import React, { Component } from 'react';
import './main-page.scss';
import { NavLink } from 'react-router-dom';
import { Transition } from 'react-spring/renderprops';

class MainPage extends Component {
    items = [
        { key: 0, text: 'Always', style: 'Always' },
        { key: 1, text: 'Delivering', style: 'Delivering' },
        { key: 2, text: 'In Time', style: 'InTime' }
    ];
    render() {
        return (
            <div className='row main main-img-background'>
                <div className='row main-words'>
                    <Transition
                        items={this.items}
                        keys={item => item.key}
                        from={{ transform: 'translate3d(0,-70px,0)', opacity: 0 }}
                        enter={{ transform: 'translate3d(0,0px,0)', opacity: 1 }}
                        trail={300}
                    >
                        {item => props => (
                            <div style={props}>
                                <span className={'main-words__' + item.style}>{item.text}</span>
                            </div>
                        )}
                    </Transition>
                    <Transition
                        items
                        from={{
                            transform: 'translate3d(0,-100px,0)',
                            opacity: 0
                        }}
                        enter={{ transform: 'translate3d(0,0,0)', opacity: 1 }}
                    >
                        {() => props => (
                            <span className='main-words__btn'>
                                <span style={props}>
                                    <NavLink className='main__hello-link' to='/contact'>
                                        Contact Us
                                    </NavLink>
                                </span>
                            </span>
                        )}
                    </Transition>
                </div>
                <Transition
                    items
                    from={{ transform: 'translate3d(-70px,0,0)', opacity: 0, width: 200 }}
                    enter={{ transform: 'translate3d(0,0,0)', opacity: 1, width: 200 }}
                >
                    {() => props => (
                        <div style={props}>
                            <span className='main__hello'>
                                <NavLink className='main__hello-link' to='/contact'>
                                    Contact Us
                                </NavLink>
                            </span>
                        </div>
                    )}
                </Transition>
            </div>
        );
    }
}

export default MainPage;
